<div>
    <vl-form-grid mod-stacked>
        <vl-column>
            <vl-title tag-name="h4">{{ title }}</vl-title>
        </vl-column>
        <vl-column v-if="isAdmin && hasSubOrganisations">
            <kl-invoice-group-edit :disable-create-button="subOrganisationsInvoiceSetting.length <= 0"
                                   :disabled-organisations="organisationsAlreadyInGroup"
                                   :invoice-group="organisationInvoiceGroupToUpdate"
                                   :sub-organisations="subOrganisations"
                                   :show-contact-info="true"
                                   @on-cancel="cancelOrganisationInvoiceGroup"
                                   @on-save="saveOrganisationInvoiceGroup"/>
        </vl-column>
        <vl-column width="12" v-for="group in organisationInvoiceGroups" :key="group.id">
            <kl-invoice-group-card :group="group" :read-only="!isAdmin"
                                   :show-contact-info="true"
                                   @on-delete="showDeleteOrganisationInvoiceGroupModal"
                                   @on-update="updateOrganisationInvoiceGroup"/>
        </vl-column>
        <template v-if="subOrganisationsInvoiceSetting.length > 1">
            <vl-column width="12"></vl-column>
            <vl-column width="12">
                <vl-title tag-name="h4">Organisaties met afzonderlijke factuur</vl-title>
            </vl-column>
            <vl-column width="6" v-for="(invoiceSetting, index) in subOrganisationsInvoiceSetting" :key="index">
                <kl-invoice-setting-card :invoice-setting="invoiceSetting"
                                         :show-contact-info="true"
                                         :read-only="!isAdmin"
                                         @on-update="updateOrganisationInvoiceSettings"/>
            </vl-column>
        </template>
        <template v-if="noSubOrganisationInvoiceSettingAndNoGroups">
            <vl-column width="6">
                <kl-invoice-setting-card :invoice-setting="organisationInvoiceData"
                                         :show-contact-info="true"
                                         :read-only="!isAdmin"
                                         @on-update="updateOrganisationInvoiceSettings"/>
            </vl-column>
            <vl-column width="6"/>
        </template>
    </vl-form-grid>

    <kl-invoice-setting-edit :show-contact-info="true" :invoice-setting="organisationInvoiceSettingToUpdate"
                             @on-save="saveOrganisationInvoiceSettings"/>

    <vl-modal id="delete-invoice-group" :closable="true">
        <vl-title tag-name="h3">Bent u zeker dat u deze facturatiegroep wil verwijderen?</vl-title>
        <vl-typography>
            Dit kan niet ongedaan worden gemaakt.
        </vl-typography>
        <vl-action-group>
            <vl-button @click="deleteOrganisationInvoiceGroup" mod-large mod-error
                       :mod-loading="deletingOrganisationInvoiceGroup"
                       :mod-disabled="deletingOrganisationInvoiceGroup">Ja, verwijder facturatiegroep
            </vl-button>
            <vl-button type="button" mod-link @click="cancelDeleteOrganisationInvoiceGroup" icon="cross"
                       mod-icon-before>
                Annuleer
            </vl-button>
        </vl-action-group>
    </vl-modal>
</div>
